/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";

import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";
import failureKey from "../../lib/common/failureKey";


function BatchUpdatePerformanceMetricDialog ( props ) {

    const { t } = useTranslation ();

    const [, setInstance] = useState ();
    const [, setDisabled] = useState ( true );

    const [schema, setSchema] = useState ();
    const [formData, setFormData] = useState({
        updateBy: "max"
    });
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    } );

    const {

        id,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        ...others

    } = props;

    useEffect ( () => {

        let schema = {
            name: "PerformanceMetric",
            type: "BASE TABLE",
            columns: [
                {
                    name: "updateBy",
                    type: "int(11)",
                    nullable: "NO",
                    required: true,
                    defaultValue: "max",
                    readonly: false,
                    disabled: false,
                    formOrder: 1,
                    formItemType: "radio",
                    row: true,
                    formControlStyle: { margin: 0, paddingTop: 0},
                    selectItems: [
                        {
                            name: t("term.min"),
                            value: "min"
                        },
                        {
                            name: t("term.max"),
                            value: "max"
                        },
                        {
                            name: t("term.avg"),
                            value: "avg"
                        },
                    ],
                    width: "100%"
                }
            ]
        };

        setSchema ( schema );

    }, [t] );

    const checkItemValidataion = ( schema, formData ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "edit", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }
            
        }

        return true;

    }

    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };    

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        setInstance ( ( instance ) => {
            instance.hide ();
            return instance;
        } );

        if ( onSuccess ) {

            onSuccess ( t ( "success.updateSuccess", { updateCount: 1 } ) );
    
        }

        setFormData ( ( formData ) => {

            let newFormData = {
                updateBy: "max",
            }

            return newFormData;

        } );

    };

    const onApiFailure = (reason) => {

        notifyFailure ( t ( failureKey ( "update", reason.response?.status ), { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

    };

    const onOk = ( schema, formData ) => {

        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        // build base api url

        let url = `/api/PerformanceMetric`;

        let apiData = {
            updateBy : formData.updateBy
        };
            
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file" ) {

                deleted[formItem] = apiData[formItem].deletedFiles;
                    
                for ( const file of apiData[formItem].activeFiles ) {

                    if ( file.type === "url" ) continue;

                    form.append ( formItem, file.file );

                }

            } else {

                if ( apiData[formItem] !== undefined ) {

                    json[formItem] = apiData[formItem];

                }

            }

        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );

        apiClient
            .put(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        setFormData ( ( formData ) => {

            let newFormData = {
                updateBy: "max",
            }

            return newFormData;

        } );

        setDisabled ( true );

        setInstance ( ( instance ) => { 
            instance.hide();
            return instance;
        } );

    };

    const onChange = ( formData ) => {

        setFormData ( formData );

        setDisabled ( false );

    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        setDisabled ( true );

        setFormData ( ( formData ) => {

            let newFormData = {
                updateBy: "max",
            }

            return newFormData;

        } );
        
        if ( onClose ) {

            onClose ();

        }
    }
    
    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="xs"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeader>
                <DialogTitle>
                    { t ( "dialog.title.PerformanceMetric.batchUpdate" ) }
                </DialogTitle>
            </DialogHeader>

            <Divider />

            <DialogContent style={{padding: "0px", height: "105px"}}>

                <div
                    style={{
                        padding: "16px"
                    }}                    
                >

                    <AutoForm
                        id="performance-metric-form"
                        schema={schema}
                        mode="edit"
                        initialData={formData}
                        onChange={onChange}
                    />

                </div>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                labels={[ t("common.update")]}
                buttonDisabled={[false, false]}
                onOk={() => onOk(schema, formData)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default BatchUpdatePerformanceMetricDialog;
